import { jsonParseFromLocalStorage } from "../Funcs/Miscellaneous";

const terms = {
  label: "Terms",
  array: [
    "duration",
    "few days",
    "few months",
    "days",
    "months",
    "hours",
    "Severe",
    "Mild",
    "Chronic",
    "sudden",
    "Recurrent",
    "left",
    "right",
  ],
};
const generalSymp = {
  label: "General",
  array: [
    "Fever",
    "Fatigue",
    "Numbness",
    "Complexion change",
    "Insomnia",
    "Tremors",
    "Sweating",
    "Drowsiness",
    "Decreases appetite",
  ],
};
const abdSymp = {
  label: "Abdomen",
  array: [
    "Epigastric pain",
    "Colicky abdominal pain",
    "Diarrhea",
    "Constipation",
    "Vomiting",
    "Bloating",
    "Anorexia",
    "Nausia",
  ],
};

const respSympt = {
  label: "Respiratory",
  array: [
    "cough",
    "Runny nose",
    "Sore throat",
    "Ear pain",
    "Ear discharge",
    "Spinning sensation",
  ],
};
const cvsSymp = {
  label: "CVS",
  array: [
    "Chest pain",
    "Dyspnea",
    "Palpitations",
    "Orthopnia",
    "HYpotension",
    "HTN accidentally",
    "Lower limb edema",
  ],
};
const kub = {
  label: "Urinary tract",
  array: [
    "dysurea",
    "frequency",
    "hesitency",
    "urine retension",
    "loin pain",
    "stress incontinence",
    "urine incontinence",
  ],
};
const Invest = [
  {
    label: "Haematology",
    array: [
      "CBC",
      "CRP",
      "ESR",
      "Ferritin",
      "LDH",
      "PT PTT INR",
      "D Dimer",
      "Fibrinogen",
      "Prot. c & S",
      "Factor V Lieden",
    ],
  },

  {
    label: "Chemstry",
    array: [
      "LFT",
      "AST",
      "ALT",
      "Bilirubin total",
      "Albumen",
      "ALK. PH.",
      "Lipase",
      "Amylase",
      "UREA & CREAT.",
      "Uric acid",
      "Urine",
      "Stool",
      "Urine Culture",
      "Stool Culture",
      "Stool occult blood",
      "Na",
      "K",
      "Ca",
      "Mg",
      "Lipid profile",
    ],
  },

  {
    label: "Immunology",
    array: [
      "Rh. Factor",
      "ANA",
      "Anti dsDNA",
      "Anti smith Ab ",
      "C3 and C4",
      "HbA1c",
      "FBS & PPBS",
      "HBV sAg",
      "HBV cAg",
      "HBV Ab",
      "HCV Ab",
      "HCV PCR",
      "IgA, Total",
      "H. Pylori Ag (stool)",
    ],
  },

  {
    label: "Hormones and Vit.",
    array: ["TSH fT3 fT4", "TSH", "Insulin", "Vit D", "Vit B"],
  },
];

const Diagnosis = [
  {
    label: "GIT",
    array: [
      "IBS",
      "Gastritis",
      "Enteritis",
      "GE",
      "? Cholecysytitis",
      "Gall stones",
      "GERD",
      "Diverticular disease",
      "Renal impairment",
    ],
  },

  {
    label: "KUB",
    array: ["UTI", "Cystitis", "Renal colic", "? Kidney stones"],
  },

  {
    label: "Respiratory",
    array: [
      "URTI",
      "Acute bronchitis",
      "Asthmatic bronchitis",
      "Sinusitis",
      "Allergic rhinitis",
      "Otitis media",
      "Otitis Externa",
      "P. P. Vertigo",
      "Pneumonia",
    ],
  },
  {
    label: "CVS",
    array: [
      "Congestive Ht. Failure",
      "IHD",
      "Valvular heart disease",
      "MSK chest pain",
    ],
  },
  {
    label: "Endocrine",
    array: [
      "DM type 1",
      "DM type 2",
      "Hyperthyroidism",
      "Hypothyroidism",
      "Grave's disease",
      "Hashimoto thyroiditis",
    ],
  },
];
const Complain = [generalSymp, abdSymp, respSympt, cvsSymp, kub];
const Present = [terms, generalSymp, abdSymp, respSympt, cvsSymp];
const Examination = [
  terms,
  {
    label: "Vital signs",
    array: [
      "-BP:    ",
      "-Pulse:   ",
      "-Temp.:    ",
      "-O2 sat:    ",
      "-RBS:    ",
    ],
  },
  {
    label: "General",
    array: [
      "Concious, oriented",
      "Pallor",
      "Jaundice",
      "Cyanosis",
      "Hyperemic",
      "Moon face",
      "Obese",
    ],
  },
  {
    label: "Head & Neck",
    array: [
      "Congested throat",
      "Congested TM",
      "Ear discharge",
      "Nasal congestion",
      "Nasal polyp",
      "Tender maxillary sinus",
      "Tender ethmoid sinus",
      "Tender frontal sinus",
      "Thyroid swelling",
      "Neck swelling",
      "Abnormal eye movement",
      "Ptosis",
      "Conjunctival injection",
    ],
  },
  {
    label: "Chest",
    array: [
      "Scar of ",
      "Limited movement on the side ",
      "Tenderness over intercostal space    on side ",
      "Hyper-resonant note side ",
      "Dull note side ",
      "Auscultation clear bilaterally equal no added sounds",
      "Fine basal creps ",
      "Creps on",
      "Expiratory wheezes",
      "Inspiratory and expiratory wheezes",
      "Decreased air entery",
      "Stridor",
    ],
  },
  {
    label: "CVS",
    array: [
      "Heart sounds normal no murmurs",
      "Systolic murmur maximum over ",
      "Diastolic murmur maximum over",
      "Aortic area",
      "Pulmonary area",
      "Apex",
      "Parasternal area",
      "Gallop",
      "Irregular irregularity",
      "Dropped beat",
      "Extra systol",
    ],
  },
  {
    label: "Abdomen",
    array: [
      "Abdomen is lax and free",
      "Tenderness over ",
      "Right hypochondrium area",
      "Left hypochondrium area",
      "Right lumbar area",
      "Left lumbar area",
      "Right inguinal area",
      "Left inguinal area",
      "Umbilical area",
      "Epigastric area",
      "Bloating",
      "Guarding",
      "Rigidity",
      "Rebound tenderness",
      "Positive McBurney,s",
      "Positive Rovsing's",
      "Enlarged liver",
      "Enlarged spleen",
      "Increased bowel sounds",
      "Dullness on percussion",
      "Shifting dullness",
    ],
  },
  {
    label: "Extremeties",
    array: [
      "L.L. edema bilateral pitting",
      "Varicose viens",
      "Swollen L.L. on side",
      "Toe candida",
      "Delayed blood refill",
      "Onchomycosis",
      "Ingrowing toe nail side ",
      "Paronychia",
      "Nail spooning",
    ],
  },
];
const treatment = [
  { label: "", array: ["Start on ", "continue until ", "Stop "] },
];
const Follow = [
  {
    label: "",
    array: [
      "After lab results",
      "revisit in xx days",
      "If not improving",
      "According to lab. results we will ",
    ],
  },
];

export const medicalVisitData = {
  Invest: Invest,
  Diagnosis: Diagnosis,
  Complain: Complain,
  Present: Present,
  Examination: Examination,
  treatment: treatment,
  Follow: Follow,
};

export const medicalVisitDataSeparators = {
  Invest: ", ",
  Diagnosis: ", ",
  Complain: " ",
  Present: " ",
  Examination: " ",
  treatment: " ",
  Follow: " ",
};

export const ClinicsData = {
  Default: {
    name: "Default clinic",
    enLabel: "Default clinic",
    arLabel: "عيادة Default",
    color: "#004F5B",
    regCollectionName: "defaultRegistrations",
    visitsCollectionName: "defaultVisits",
    homeCareCollectionName: "defaulthomecarevisits",
    ptUrl: "https://elhallclinics.web.app",

    prices: {
      Consultation: 0,
      Revisit: 0,
      Sonar: 0,
      ECG: 0,
      Nebulizer: 0,
      Fluids: 0,
      Lab: 0,
      Others: 0,
      Radio: 0,
      Unpaid: 0,
    },
  },
  Clinic1: {
    name: "Clinic1",
    enLabel: "Shobra clinic",
    arLabel: "عيادة شبرا",
    color: "#004F5B",
    regCollectionName: "newRegistrations",
    visitsCollectionName: "newVisits",
    homeCareCollectionName: "homecarevisits",
    ptUrl: "https://elhallclinics.web.app",
    prices: {
      Consultation: 200,
      Revisit: 50,
      Sonar: 100,
      ECG: 80,
      Nebulizer: 80,
      Fluids: 150,
      Lab: 0,
      Others: 0,
      Radio: 150,
      Unpaid: 0,
    },
  },
  Clinic2: {
    name: "Clinic2",
    enLabel: "Aghakhan clinic",
    arLabel: "عيادة أغاخان",
    color: "red",
    regCollectionName: "newRegistrations2",
    visitsCollectionName: "newVisits2",
    homeCareCollectionName: "homecarevisits2",
    ptUrl: "https://elhallclinics.web.app",
    prices: {
      Consultation: 350,
      Revisit: 50,
      Sonar: 100,
      ECG: 80,
      Nebulizer: 80,
      Fluids: 150,
      Lab: 0,
      Others: 0,
      Radio: 150,
      Unpaid: 0,
    },
  },
  Clinic3: {
    name: "Clinic3",
    enLabel: "Aghakhan clinic",
    arLabel: "عيادة أغاخان",
    color: "olive",
    regCollectionName: "newRegistrations3",
    visitsCollectionName: "newVisits3",
    homeCareCollectionName: "homecarevisits3",
    logo: process.env.PUBLIC_URL + "/clinicLogo.png",
    ptUrl: "https://elhallclinics.web.app",
    prices: {
      Consultation: 200,
      Revisit: 50,
      Sonar: 100,
      ECG: 80,
      Nebulizer: 80,
      Fluids: 150,
      Lab: 0,
      Others: 0,
      Radio: 150,
      Unpaid: 0,
    },
  },
};

export const ServicesConstPrices = () => {
  const currentClinic = jsonParseFromLocalStorage(
    "currentClinic",
    ClinicsData["Default"]
  );
  return currentClinic.prices;
};

export const ServicesConst = {
  Consultation: false,
  Revisit: false,
  Sonar: false,
  ECG: false,
  Nebulizer: false,
  Fluids: false,
  Lab: false,
  Others: false,
  Radio: false,
  Unpaid: false,
};

export const BasicColor = jsonParseFromLocalStorage(
  "currentClinic",
  ClinicsData["Default"]
).color;
export const GreenContrast = "#f4fdf1";
export const ContrastColor = "white";
export const ClinicColors = { Clinic1: "#004F5B", Clinic2: "red" };

export const VisitTypesConst = ["Consultation", "Revisit", "Others"];

export const adminPass = "asmaa";
export const docId = "1";

// export const isHomevisit = false;

// npm run build
// true:
// "site": "homevisit",
// "site": "elhallclinics",

//firebase deploy --only hosting:homevisit
// firebase deploy --only hosting:elhallclinics

// false:
//"site": "elhall-clinic-admin",
// firebase deploy --only hosting:elhall-clinic-admin
